import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { Translate } from 'react-jhipster';
import { getEleve, deleteEleve } from './eleve.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const EleveDeleteModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const eleve = useAppSelector(state => state.eleve.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getEleve(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/eleve/${props.match.params.ecoleid}`);
  };

  const confirmDelete = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      page: 0,
      size: 0,
    };
    dispatch(deleteEleve(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {eleve.id !== null && (
        <Modal
          title="Confirmation de suppression"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
              Supprimer
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Etes-vous certain de vouloir supprimer l&apos;élève {eleve.firstName} {eleve.lastName} ?
        </Modal>
      )}
    </>
  );
};

export default EleveDeleteModal;
